import http from '../config'

const vip = {
  vipDetail() {
    return http({
      url: 'vip/detail',
      withoutLogin: true
    })
  },
  vipProducts(method = 'GET', data = null) {
    return http({
      url: 'vip/products',
    })
  },
  vipCreateOrder(data) {
    return http({
      url: 'vip/create_order',
      data,
      method: "POST"
    })
  },
  getCoupon() {
    return http({
      url: 'coupon/get/new_vip?type=key',
      method: "POST"
    })
  }
}

export default vip
